import { render, staticRenderFns } from "./DealsTable.vue?vue&type=template&id=68c750d5"
import script from "./DealsTable.vue?vue&type=script&lang=js"
export * from "./DealsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports